function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.8043e-5 -290.12)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "scale(.26458)",
  d: "m16.855 1096.5c-1.5964-0.1052-0.39218 2.3234-4.0176 2.3926-4.462 0.085-1.7428-3.68-5.7266-1.6367-3.9837 2.0433 0.61291 2.0575-2.1035 5.6543-2.7164 3.5967-3.9209-0.9104-4.832 3.5273-0.9111 4.4378 1.9663 0.7955 3.041 5.1953 1.0747 4.3999-3.1445 2.5467-0.29688 6.0372 2.8476 3.4904 1.838-1.0656 5.8945 0.8242 4.0565 1.8897-0.00108 4.0852 4.4609 4 4.462-0.085 0.32681-2.1247 4.3105-4.168 3.9837-2.0433 3.1429 2.5479 5.8594-1.0488 2.7164-3.5968-1.4306-1.5837-0.51953-6.0215s3.9204-0.9088 2.8457-5.3086-2.1114 0.1506-4.959-3.3398c-2.8476-3.4905 1.746-3.6806-2.3105-5.5704-0.7606-0.3543-1.2781-0.5128-1.6465-0.5371zm-3.8555 8.9961a4 4 0 0 1 4 4 4 4 0 0 1-4 4 4 4 0 0 1-4-4 4 4 0 0 1 4-4z"
}));

var SvgSettings = function SvgSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 6.8792 6.8791",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings.5882495a.svg";
export { ForwardRef as ReactComponent };